import React from "react"
import { Modal, Button } from "antd"
import "./TermsOfService.scoped.scss"

const TermsOfService = ({ open, setOpen }) => {
  const termsData = {
    title: "เงื่อนไขการใช้บริการ Terms Of Use (SMS)",
    lastUpdated: "บันทึก ณ วันที่ 17 มิถุนายน 2568",
    announcement: "ประกาศฉบับนี้ให้มีผลบังคับใช้ตั้งแต่วันที่ 17 มิถุนายน 2568 เป็นต้นไป",
    sections: [
      {
        content: "ข้อตกลงการใช้บริการฉบับนี้ ต่อไปนี้เรียกว่า \"ข้อตกลง\" จัดทำขึ้นเพื่อใช้บังคับระหว่างบริษัท แอดวานซ์ เน็ตเวิร์ค เทคโนโลยี แอนด์ เซอร์วิส จำกัด และผู้ใช้บริการ โดยมีรายละเอียดดังนี้ ผู้ใช้บริการถือว่ายอมรับข้อตกลงฉบับนี้โดยสมบูรณ์ เมื่อเริ่มใช้งานระบบของบริษัท"
      },
      {
        title: "1. ขอบเขตการให้บริการ",
        content:
          "ผู้ใช้บริการตกลงที่จะใช้ระบบของบริษัทเพื่อวัตถุประสงค์ในการส่งข้อความเท่านั้น โดยต้องไม่ส่งข้อความในลักษณะที่เป็นการรบกวน ละเมิดสิทธิ หรือผิดกฎหมาย รวมถึงแต่ไม่จำกัดเฉพาะข้อความที่มีเนื้อหา หมิ่นประมาท ลามกอนาจาร ยุยงปลุกปั่น ดูหมิ่นศาสนา หรือเป็นอันตรายต่อความมั่นคงของประเทศ",
      },
      {
        title: "2. การใช้งานลิงก์ (URL) ร่วมกับข้อความ",
        content:
          "การส่งข้อความที่มีการแนบลิงก์จะต้องผ่านการลงทะเบียนล่วงหน้า โดยต้องระบุชื่อผู้ส่งและปลายทางของ URL อย่างชัดเจน ห้ามใช้ลิงก์ที่นำผู้ใช้งานไปยังเนื้อหาที่ไม่ตรงตามวัตถุประสงค์ หรือที่บริษัทไม่ได้รับทราบล่วงหน้า หากฝ่าฝืน บริษัทสงวนสิทธิ์ในการระงับบัญชีผู้ใช้ทันที",
      },
      {
        title: "3. ค่าบริการและเครดิต",
        content:
          "ระบบจะคิดค่าบริการตามจำนวนตัวอักษรที่ส่ง โดยภาษาไทยสูงสุด 70 ตัวอักษรต่อ 1 เครดิต และภาษาอังกฤษ 160 ตัวอักษรต่อ 1 เครดิต ในกรณีมีการใช้ตัวอักษรผสมหรือเกินจำนวนที่กำหนด ระบบจะคิดเครดิตเพิ่มเติมโดยอัตโนมัติ",
      },
      {
        title: "4. ความรับผิดชอบของบริษัท",
        content:
          "บริษัททำหน้าที่เป็นผู้ให้บริการเทคโนโลยี ไม่สามารถตรวจสอบหรือควบคุมเนื้อหาที่ผู้ใช้ส่งได้โดยตรง ดังนั้นผู้ใช้ต้องเป็นผู้รับผิดชอบแต่เพียงผู้เดียวต่อเนื้อหาทั้งหมดที่ส่งผ่านระบบ และหากมีข้อพิพาทหรือความเสียหายเกิดขึ้น ผู้ใช้จะต้องรับผิดชอบทั้งหมดในนามตนเอง",
      },
      {
        title: "5. นโยบายการยกเลิกและคืนเงิน ",
        content:
          "บริษัทไม่มีนโยบายให้ลูกค้าทำการยกเลิกคำสั่งซื้อหรือขอคืนเงินภายหลังการชำระเงินเรียบร้อยแล้วในทุกกรณี ยกเว้นเฉพาะกรณีที่เกิดจากความผิดพลาดของระบบหรือเจ้าหน้าที่ของบริษัทเท่านั้น ทั้งนี้ หากพบเหตุขัดข้องที่อยู่ในความรับผิดชอบของบริษัท กรุณาติดต่อฝ่ายบริการลูกค้าภายใน 7 วันนับ[PK1.1]จากวันที่พบปัญหา เพื่อขอรับการตรวจสอบ",
        additiondal: "รายละเอียดเพิ่มเติม:",
        additionalTerms: [
          "ผู้ใช้บริการต้องตรวจสอบประเภทของเครดิตก่อนชำระเงิน",
          "บริษัทจะไม่ดำเนินการโอนย้ายเครดิตหากเกิดความผิดพลาดจากฝั่งลูกค้า",
          "การคืนเงินที่อยู่นอกเหนือเงื่อนไขข้างต้น อาจถูกปฏิเสธได้ตามดุลยพินิจของบริษัท",
          "หากมีการคืนเงิน บริษัทจะคืนผ่านวิธีการชำระเงินแบบเดียวกับที่ลูกค้าใช้ในครั้งแรกเท่านั้น",
        ],
      },
      {
        title: "6. วันหมดอายุและการจัดการบัญชี",
        content:
          "เครดิตที่ได้รับจากการสั่งซื้อบริการมีอายุการใช้งานตามระยะเวลาที่ระบุไว้ในใบเสนอราคา หรือเอกสารสัญญาที่เกี่ยวข้อง ณ วันที่ทำการชำระเงิน โดยจะหมดอายุตามที่กำหนดไว้โดยชัดแจ้งในเอกสารดังกล่าว \nหากเครดิตหมดอายุและยังไม่ได้มีการใช้งาน ผู้ใช้บริการจะถือว่าสละสิทธิ์ในเครดิตนั้นโดยอัตโนมัติ และบริษัทขอสงวนสิทธิ์ในการ ไม่คืนเงินหรือชดเชย ในทุกกรณี ไม่ว่าบางส่วนหรือทั้งหมด \nบริษัทขอสงวนสิทธิ์ในการปรับเปลี่ยนเงื่อนไขอายุการใช้งานเครดิตสำหรับการซื้อในอนาคต โดยจะแจ้งให้ทราบผ่านช่องทางที่เหมาะสม เช่น เว็บไซต์, อีเมล, หรือแนบท้ายใบเสนอราคา \nบัญชีผู้ใช้สำรอง (Sub-account) ต้องได้รับอนุมัติจากบัญชีหลัก (Main account) และไม่สามารถสั่งซื้อแพ็กเกจ หรือใช้เครดิตร่วมกับบัญชีอื่นได้",
      },
      {
        title: "7. การระงับการให้บริการ",
        content:
          "บริษัทขอสงวนสิทธิ์ในการระงับบัญชีของผู้ใช้โดยไม่ต้องแจ้งล่วงหน้า หากตรวจพบการกระทำที่ขัดต่อข้อตกลงหรือผิดกฎหมาย รวมถึงกรณีที่ผู้ใช้ไม่สามารถพิสูจน์ตัวตนหรือไม่มีการเติมเครดิตเกินระยะเวลาที่กำหนด[",
      },
      {
        title: "8. มาตรการรักษาความปลอดภัย",
        content:
          "บริษัทมีระบบรักษาความปลอดภัยด้วยการเข้ารหัส SSL Green Bar (Secure Sockets Layer) และการยืนยันตัวตนแบบสองขั้นตอน (Two-Factor Authentication – 2FA) เพื่อป้องกันการเข้าถึงโดยไม่ได้รับอนุญาต และเสริมความมั่นใจในการใช้งานของผู้ใช้บริการ",
      },
      {
        title: "9. การติดต่อสอบถาม",
        content:
          "-	สอบถามทั่วไป / ส่งคำร้องเรียน / ติดต่อธุรกรรมทั่วไป \nอีเมล: info@ants.co.th \n-	แจ้งปัญหาเชิงเทคนิค / การใช้งานระบบ / ขอความช่วยเหลือด้านระบบ \nอีเมล: support@ants.co.th",
      },
      {
        title: "10. การแก้ไขข้อตกลง",
        content:
          "บริษัทขอสงวนสิทธิ์ในการปรับปรุง เปลี่ยนแปลง หรือเพิ่มเติมข้อตกลงฉบับนี้ได้ทุกเมื่อ โดยจะแจ้งให้ผู้ใช้ทราบล่วงหน้าผ่านช่องทางเว็บไซต์หรือการสื่อสารอิเล็กทรอนิกส์ที่เหมาะสม ในกรณีที่มีข้อโต้แย้งเกี่ยวกับเนื้อหาในข้อตกลงนี้ ให้อ้างอิงตามข้อความภาษาไทยเป็นหลัก",
      },
      {
        title: "11. มาตรการรักษาความปลอดภัย",
        content:
          "บริษัทอาจใช้ชื่อองค์กร หรือโลโก้ของผู้ใช้บริการ เพื่อแสดงเป็นลูกค้าอ้างอิงบนเว็บไซต์ งานนำเสนอ หรือสื่อประชาสัมพันธ์อื่น ๆ ของบริษัท โดยการใช้งานดังกล่าวจะกระทำ ภายใต้กรอบความเหมาะสมและไม่มีการเปิดเผยข้อมูลเชิงลึก[PK4.1] หรือข้อมูลส่วนบุคคลของผู้ใช้บริการ เว้นแต่จะได้รับความยินยอมเพิ่มเติมอย่างเป็นทางการ หากผู้ใช้บริการไม่ประสงค์ให้ใช้ชื่อหรือโลโก้ดังกล่าว กรุณาแจ้งเป็นลายลักษณ์อักษรล่วงหน้า ผ่านช่องทางการติดต่อของบริษัท",
      },
    ],
  }

  return (
    <Modal
      visible={open}
      onCancel={() => setOpen("")}
      footer={null}
      centered
      width={600}
      className="terms-of-service-modal"
      closeIcon={false}
      zIndex={1021}
    >
      <div className="terms-modal-container">
        <div className="terms-modal-title">{termsData.title}</div>

        <div className="terms-modal-updated">{termsData.lastUpdated}</div>

        <div className="terms-modal-content">
          {termsData.sections.map((section, index) => (
            <div key={index} className="terms-modal-section-detail">
              {section.title && <div className="terms-modal-section-title">{section.title}</div>}

              {section.content.split("\n").map((line, i) => (
                <div key={i} className="terms-modal-paragraph">
                  {line}
                </div>
              ))}

              {section.additiondal && <div className="terms-modal-paragraph mt-3">{section.additiondal}</div>}

              {/* Only render additional terms if they exist for this section */}
              {section.additionalTerms && (
                <div className="terms-modal-list">
                  {section.additionalTerms.map((term, termIndex) => (
                    <div key={termIndex} className="terms-modal-list-item">
                      • {term}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}

        </div>

        <div className="terms-modal-updated mb-3">{termsData.announcement}</div>

        <Button className="terms-modal-done-btn" type="primary" block onClick={() => setOpen(false)}>
          Done
        </Button>
      </div>
    </Modal>
  )
}

export default TermsOfService
